import { Info } from "@phosphor-icons/react";

import { CouponPill } from "features/subscriptions/components";
import type { InvoiceEstimate } from "features/subscriptions/types";
import {
  getCouponDiscountString,
  parseEstimate,
} from "features/subscriptions/utils";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

type AppliedCouponProps = (
  | { estimate: InvoiceEstimate }
  | { couponId: string }
) & {
  onRemove: () => void;
};

export default function AppliedCoupon({
  onRemove,
  ...rest
}: AppliedCouponProps) {
  let couponPillText: string;
  let couponDiscountText: string;

  if ("estimate" in rest) {
    const { coupon } = parseEstimate(rest.estimate);

    couponPillText = coupon.name;
    couponDiscountText = getCouponDiscountString(coupon);
  } else {
    couponPillText = rest.couponId;
  }

  return (
    <div className="px-2 py-1 flex flex-col border gap-y-1 border-purple-50 bg-purple-25 rounded-xl">
      <div className="flex justify-between items-center">
        <div className="flex items-center">
          <span className="text-button-sm text-black-600 ">Coupon name</span>
          <Tooltip>
            <TooltipTrigger className="ml-1 mr-auto">
              <Info weight="fill" className="size-4 text-black-300" />
            </TooltipTrigger>
            <TooltipContent>
              The currently applied coupon to this subscription
            </TooltipContent>
          </Tooltip>
        </div>

        <CouponPill onRemove={onRemove}>{couponPillText}</CouponPill>
      </div>
      {couponDiscountText && (
        <span className="ml-auto text-xs text-yellow-500">
          {couponDiscountText}
        </span>
      )}
    </div>
  );
}
